import stopsaleService from '@/services/stopsale.service'

const state = {
    loading: false,
    loadingReport: false,
    hotels: [],
    regions: [],
    stopsales: [],
    results: [],
    report: null,
    searchPerformed: false
}

const getters = {

}

const mutations = {
    setHotels(state, hotels = []) {
        state.hotels = hotels;
    },
    setRegions(state, regions = []) {
        state.regions = regions;
    },
    setLoading(state, loading = false) {
        state.loading = loading;
    },
    setLoadingReport(state, loading = false) {
        state.loadingReport = loading;
    },
    setStopsales(state, stopsales = []) {
        state.stopsales = stopsales;
    },
    setResults(state, results = []) {
        state.results = results;
    },
    setReport(state, report) {
        state.report = report;
    },
    setSearchPerformed(state, value) {
        state.searchPerformed = value;
    },


}

const actions = {
    clearResult({ commit }) {
        commit('setResults', []);
    },
    getHotels ({ commit }) {
        stopsaleService.getHotels().then(response => {
            commit('setHotels', response);
        }).catch(() => {
        })
    },

    getRegions ({ commit }) {
        stopsaleService.getRegions().then(response => {
            commit('setRegions', response);
        }).catch(() => {
        })
    },

    setLoading({ commit }, loading = false) {
        commit('setLoading', loading);
    },

    setLoadingReport({ commit }, loading = false) {
        commit('setLoadingReport', loading);
    },

    getStopsalesReport ({ commit }, params) {
        commit('setLoading', true);
        stopsaleService.getStopsalesReportForFilter(params).then(response => {
            commit('setResults', response);
            commit('setLoading', false);
            commit('setSearchPerformed', true);
        }).catch(() => {
            commit('setLoading', false);
        })
    },

    downloadStopSalesReport ({ commit }, params) {
        return stopsaleService.getStopSalesReport(params).then(response => {
            commit('setReport', response);
            return response;
        }).catch(() => {
            
        })
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}